import {httpStoreTeam, HttpStoreTeamOptions} from '@/features/treatment-requests/teams/http/teams.http'
import {MUTATION_KEYS} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {TeamMember} from '@/features/treatment-requests/teams/types'

export const useStoreTeam = (
    treatmentRequestId: string,
    options?: UseMutationOptions<TeamMember[], AxiosError<ErrorResponseData>, HttpStoreTeamOptions['payload']>
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.STORE_TEAM, treatmentRequestId],
        mutationFn: (payload: HttpStoreTeamOptions['payload']) =>
            httpStoreTeam({urlParams: {treatmentRequestId}, payload})
    })
}
